import saveAs from 'file-saver';

import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async getCashLogList(params) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/cash-logs/',
      method: HttpMethod.GET
    };

    try {
      const { xlsx, page } = params;

      const showLoader = (page === 1) && !xlsx;

      const res = await processRequest(ep, {
        params,
        responseType: xlsx ? 'blob' : undefined
      }, showLoader);

      if (xlsx) return res.data;

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async exportXlsx(params) {
    const data = await this.getCashLogList({
      ...params,
      xlsx: 1
    });

    const { fromDate, toDate } = params;

    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const filename = `cashlog__${fromDate}__${toDate}.xlsx`;
    saveAs(blob, filename);
  },

  async getCashLogPendingList(params) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/cash-logs/pending/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, { params });
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getCashLogSummary(params) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/cash-logs/summary/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, { params });
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getCashLogCategories() {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/cash-log-categories/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {}, false);
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async updateCashLogStatus(id, status) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v1/cash-logs/${id}/status/`,
      method: HttpMethod.PUT
    };

    try {
      const res = await processRequest(ep, { data: { status } });
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async createCashLog(data, fileImport = false) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: fileImport ? '/v1/cash-logs:upload/' : '/v1/cash-logs/',
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });
      processSuccessResponse(res);
      return true;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getCashClosureList(params = {}) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/cash-closures/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, { params });
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async createCashClosure(data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/cash-closures/',
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });
      processSuccessResponse(res);
      return true;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async removeCashClosure(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v1/cash-closures/${id}/`,
      method: HttpMethod.DELETE
    };

    try {
      const res = await processRequest(ep);
      processSuccessResponse(res);
      return true;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  }
};
